import { render, staticRenderFns } from "./PillOutlineButtons.vue?vue&type=template&id=6f6224ec"
import script from "./PillOutlineButtons.vue?vue&type=script&lang=js"
export * from "./PillOutlineButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports